(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
document.addEventListener("DOMContentLoaded", () => {
  const articles = document.querySelectorAll(".article-grid-card");
  const loadMoreBtn = document.getElementById("load-more");
  const displayingItems = +document.querySelector(
    ".articles-tabs-cards-wrapper[data-show-items]"
  ).dataset.showItems;

  let visibleCount = displayingItems;

  function showArticles() {
    articles.forEach((article, index) => {
      if (index < visibleCount) {
        article.style.display = "block";
      }
    });

    if (visibleCount >= articles.length) {
      loadMoreBtn.style.display = "none";
    }
  }

  showArticles();

  loadMoreBtn?.addEventListener("click", () => {
    visibleCount += displayingItems;
    showArticles();
  });
});

},{}]},{},[1])

